import { Button, Card, Form, Input, Select } from "antd";
import { Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEmployees, updateEmployees } from "../../../../actions/employees";
import { APP_BASE_URL } from "../../../../config/Axios";
import { findLodash, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import * as Yup from "yup";
import { getRoles } from "../../../../actions/companySettings";

const getValidationSchema = (isEdit) =>
  Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    primary_phone: Yup.string()
      .matches(/^\d{10}$/, "Phone must be 10 digits")
      .required("Phone is required"),
    name: Yup.string().required("Name is required"),
    roles: Yup.string().nullable().required("Role is required"),
    password: isEdit
      ? Yup.string()
      : Yup.string()
        .required("Please enter password!")
        .min(12, "Please enter atleast 12 characters!"),
  });
const AddCorporateForm = (props) => {
  const dispatch = useDispatch();
  const rolesResponse = useSelector(
    (state) => state.companySetting.getRoles || {}
  );
  const { data: { response: { roles: rolesData = [] } = {} } = {} } =
    rolesResponse;

  const addEmployeesResponse = useSelector(
    (state) => state.employees.addEmployees || {}
  );

  const updateEmployeesResponse = useSelector(
    (state) => state.employees.updateEmployees || {}
  );

  const employeesResponse = useSelector(
    (state) => state.employees.employees || {}
  );

  const editValues =
    findLodash(employeesResponse?.data?.response?.checkers, {
      id: props.selectedId,
    }) || {};

  useEffect(() => {
    dispatch(getRoles({ is_corporate_checker: true }));
    return () => {
      dispatch(getRoles({}));
    };
  }, []);

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`New Corporate Checker`}
          navigation={{
            "Enter corporate details and submit": "",
          }}
        />
      </div>
      <Card>
        <Formik
          initialValues={{
            email: editValues.email ?? "",
            primary_phone: editValues.primary_phone ?? "",
            roles: editValues?.roles?.[0] ?? null,
            name: editValues.name ?? "",
            password: "",
            is_corporate_checker: true,
          }}
          validationSchema={getValidationSchema(!!props.selectedId)}
          onSubmit={(values) => {
            if (props.selectedId) {
              delete values.password;
              dispatch(
                updateEmployees(
                  objectToFormData({
                    ...values,
                    id: props.selectedId,
                    roles: [values.roles],
                  })
                )
              );
            } else {
              dispatch(
                addEmployees(
                  objectToFormData({
                    ...values,
                    redirect_url: APP_BASE_URL,
                    roles: [values.roles],
                  })
                )
              );
            }
          }}
        >
          {({
            values,
            handleChange,
            handleSubmit,
            setFieldValue,
            errors,
            touched,
            handleBlur,
            submitCount,
          }) => (
            <Form
              layout="vertical"
              onFinish={handleSubmit}
              style={{
                width: "35%",
              }}
            >
              <Form.Item
                label="Name"
                validateStatus={
                  submitCount > 0 && errors.name && touched.name
                    ? "error"
                    : ""
                }
                help={submitCount > 0 && errors.name ? errors.name : null}
                required={true}
              >
                <Input
                  name="name"
                  placeholder="Enter Name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Item>
              <Form.Item
                label="Email"
                validateStatus={
                  submitCount > 0 && errors.email && touched.email
                    ? "error"
                    : ""
                }
                help={submitCount > 0 && errors.email ? errors.email : null}
                required={true}
              >
                <Input
                  name="email"
                  placeholder="Enter Email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Form.Item>

              <Form.Item
                label="Mobile Number"
                validateStatus={
                  submitCount > 0 &&
                    errors.primary_phone &&
                    touched.primary_phone
                    ? "error"
                    : ""
                }
                help={
                  submitCount > 0 && errors.primary_phone
                    ? errors.primary_phone
                    : null
                }
                required
              >
                <span className="ant-input-group-wrapper">
                  <span className="ant-input-wrapper ant-input-group">
                    <span className="ant-input-group-addon">+91</span>
                    <input
                      placeholder="Enter Number"
                      maxlength="10"
                      type="text"
                      className="ant-input"
                      value={values.primary_phone}
                      disabled={props.selectedId}
                      name="primary_phone"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        if (new RegExp(/^[0-9]*$/).test(e.target.value)) {
                          setFieldValue("primary_phone", e.target.value);
                        }
                      }}
                    />
                  </span>
                </span>
              </Form.Item>
              {props.selectedId ? null : (
                <Form.Item
                  name="password"
                  label="Password"
                  required={true}
                  help={
                    submitCount > 0 && errors.password ? errors.password : null
                  }
                  validateStatus={
                    submitCount > 0 && errors.password && touched.password
                      ? "error"
                      : ""
                  }
                >
                  <Input.Password
                    name="password"
                    placeholder="Enter Password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Role"
                required
                validateStatus={
                  submitCount > 0 && errors.roles && touched.roles
                    ? "error"
                    : ""
                }
                help={submitCount > 0 && errors.roles ? errors.roles : null}
              >
                <Select
                  placeholder="Select Role"
                  value={values.roles}
                  onChange={(val) => setFieldValue("roles", val)}
                  onBlur={() => handleBlur({ target: { name: "roles" } })}
                >
                  {rolesData &&
                    rolesData?.map(({ id, role_name }) => (
                      <Select.Option key={id} value={role_name}>
                        {role_name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="formButton mt1 primaryButton"
                  disabled={
                    addEmployeesResponse?.loading ||
                    updateEmployeesResponse?.loading
                  }
                >
                  Submit
                </Button>
                <Button
                  key="2"
                  className="cancelButton ml1 mt1"
                  onClick={() => {
                    props.handleAdd();
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
            </Form>
          )}
        </Formik>
      </Card>
    </>
  );
};

export default AddCorporateForm;
